module.exports = require("skypager-util/lib/path-matcher");


//////////////////
// WEBPACK FOOTER
// external "skypager-util/lib/path-matcher"
// module id = 7
// module chunks = 0 1 2 3 4 5 6 7 8 9 15 21